// extracted by mini-css-extract-plugin
export default {"root":"shPagination_root__volwI"};